import React, { useEffect, useState, useMemo } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import AxelInput from "../../UI/AxelInput";
import Wrapper from "../../components/Wrapper";
import Breadcrumbs from "../../components/Breadcrumbs";
import "./index.scss";

export default function Projects() {
    const navigate = useNavigate();
    const location = useLocation();
    const [searchText, setSearchText] = useState("");
    const [glossary, setGlossary] = useState(null);
    let emptyDataText = "No Sections"

    useEffect(() => {
        const userToken = localStorage.getItem("user_token");
        const glossaryData = localStorage.getItem("glossary");

        if (!userToken) {
            navigate("/login");
        }

        if (!glossaryData) {
            navigate("/manage-glossary");
        } else {
            setGlossary(JSON.parse(glossaryData));
        }
    }, [navigate]);

    const lastPathname = useMemo(() => decodeURIComponent(location.pathname.split('/').pop()), [location.pathname]);

    const matchedItem = useMemo(() => {
        return glossary?.find(section =>
            section.name.toLowerCase() === lastPathname.toLowerCase()
        );
    }, [glossary, lastPathname]);

    const filteredSections = useMemo(() => {
        return matchedItem?.sections?.filter(project =>
            project.name.toLowerCase().includes(searchText.toLowerCase())
        ) || [];
    }, [matchedItem, searchText]);

    const renderList = () => {
        return filteredSections.map(item => (
            <Link
                key={item.name}
                to={`${location.pathname}/${item.name.replace(/\//g, '-')}`}
                state={item} className="glossary__item"
            >
                <p className="glossary__item-text">{item.name}</p>
                <div className="glossary__item-right">
                    <div className="glossary__item-arrow">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fillRule="evenodd" clipRule="evenodd" d="M18.5303 12.5303C18.8232 12.2374 18.8232 11.7626 18.5303 11.4697L14.5303 7.46967C14.2374 7.17678 13.7626 7.17678 13.4697 7.46967C13.1768 7.76256 13.1768 8.23744 13.4697 8.53033L16.1893 11.25L6 11.25C5.58579 11.25 5.25 11.5858 5.25 12C5.25 12.4142 5.58579 12.75 6 12.75L16.1893 12.75L13.4697 15.4697C13.1768 15.7626 13.1768 16.2374 13.4697 16.5303C13.7626 16.8232 14.2374 16.8232 14.5303 16.5303L18.5303 12.5303Z" fill="#2A3650"/>
                            <path d="M18.5303 11.4697C18.8232 11.7626 18.8232 12.2374 18.5303 12.5303L14.5303 16.5303C14.2374 16.8232 13.7626 16.8232 13.4697 16.5303C13.1768 16.2374 13.1768 15.7626 13.4697 15.4697L16.9708 12.0025L13.4697 8.53033C13.1768 8.23744 13.1768 7.76256 13.4697 7.46967C13.7626 7.17678 14.2374 7.17678 14.5303 7.46967L18.5303 11.4697Z" fill="#2A3650"/>
                        </svg>
                    </div>
                </div>
            </Link>
        ));
    };

    return (
        <Wrapper classname="glossary">
            <Breadcrumbs/>
            <div className="glossary__header">
                <h1 className="text-dark text-[36px] dashboard__title">Sections</h1>
                <AxelInput
                    className="glossary__header__search"
                    src={'/assets/icons/search.svg'}
                    placeholder="Search"
                    value={searchText}
                    handler={(e) => setSearchText(e.target.value)}
                />
            </div>
            <div className="glossary__list">
                {filteredSections?.length <=0 ? (
                    <div style={{ height: '70vh', width: '100%', display: "flex", justifyContent: "center", alignItems: 'center', flexDirection: "column" }}>
                        <img src="/assets/images/projects.png" alt="" />
                        <span style={{ color: "#767676", fontSize: 16, fontWeight: 500 }}> {emptyDataText}</span>
                    </div>): renderList()}
            </div>
        </Wrapper>
    );
}
